import {Breadcrumbs, ErrorPopup, name, Notice, Title} from '@management-ui/core';
import {reverse} from 'named-urls';
import React, {useCallback, useContext, useEffect, useMemo, useState} from 'react';
import routes from '../../../../routes';
import {ServiceContext} from '../../../../components/Services';
import {useSelector} from 'react-redux';
import {FormControl, InputLabel, MenuItem, Select} from '@mui/material';
import {useOptions} from '../../../../hooks';

const Wrapper = ({title, loading, titleControls, job, jobUpdated, crumbs, errors, children}) => {
  const services = useContext(ServiceContext);
  const user = useSelector(state => state['auth'].user);
  const [assignedUser, setAssignedUser] = useState(undefined);
  const [assigning, setAssigning] = useState(false);
  const allUsers = useOptions('users');
  const users = useMemo(() => allUsers.filter(user => user.is_admin), [allUsers])

  useEffect(() => {
    if (job) {
      setAssignedUser(job.assigned_user);
    }
  }, [job]);

  const handleUserChange = useCallback((event) => {
    const selected = users.find((user) => user.id === event.target.value);
    setAssignedUser(selected);
    setAssigning(true);
    services.job.saveJob({id: job.id, assigned_user_id: selected?.id ?? null}).then((updated) => {
      setAssigning(false);
      jobUpdated(updated);
    }).catch(() => setAssigning(false));
  }, [job, jobUpdated, services, users]);

  return (
    <>
      <Breadcrumbs crumbs={crumbs}/>
      <Title title={title} loading={loading} controls={titleControls}>
        {!loading && job && user && users.length ? (
          <FormControl>
            <InputLabel id="assigned-user-label">Assigned User</InputLabel>
            <Select
              labelId="assigned-user-label"
              id="assigned-user"
              value={assignedUser?.id ?? 0}
              label="Assigned User"
              onChange={handleUserChange}
              disabled={!user.is_superuser || assigning}
            >
              <MenuItem value={0}>Unassigned</MenuItem>
              {users.map((user, index) => (
                <MenuItem key={index} value={user.id}>{name(user)}</MenuItem>
              ))}
            </Select>
          </FormControl>
        ) : null}
      </Title>
      <Notice
        display={job && job.archived}
        message={[
          'This job has been archived and is therefore no longer available.',
          'You won\'t be able to modify it unless it is restored.'
        ].join(' ')}
      />
      {children}
      <ErrorPopup errors={['job']} messages={errors}/>
    </>
  );
}

Wrapper.standardCrumbs = [
  {title: 'Jobs', link: routes.jobs.index}
];
Wrapper.archiveCrumbs = [
  {title: 'Archive', link: reverse(routes.archive.index)},
  {title: 'Jobs', link: reverse(routes.archive.index, {tab: 'jobs'})}
];

export default Wrapper;
